export const API_REQUEST = 'API_REQUEST';
export const API_REQUEST_START = 'API_REQUEST_START';
export const API_REQUEST_END = 'API_REQUEST_END';
export const API_REQUEST_SUCCESS = 'API_REQUEST_SUCCESS';
export const API_REQUEST_FAILURE = 'API_REQUEST_FAILURE';
